/**
 * trackOnboardingEvent — שולח אירוע ל-analytics אם קיים.
 * לא שובר את המערכת אם אין analytics מוגדר.
 *
 * @param {string} eventName
 * @param {object} [payload]
 */
export function trackOnboardingEvent(eventName, payload = {}) {
  try {
    if (typeof window === "undefined") return;

    // Mixpanel
    if (window.mixpanel?.track) {
      window.mixpanel.track(eventName, payload);
      return;
    }

    // PostHog
    if (window.posthog?.capture) {
      window.posthog.capture(eventName, payload);
      return;
    }

    // Google Analytics 4
    if (window.gtag) {
      window.gtag("event", eventName, payload);
      return;
    }

    // fallback — dev log בלבד
    if (process.env.NODE_ENV === "development") {
    }
  } catch (err) {
    // בשום מקרה לא שוברים את המערכת
    if (process.env.NODE_ENV === "development") {
      console.warn("[trackOnboardingEvent] failed silently:", err);
    }
  }
}
